export default __webpack_public_path__ + "static/media/opera.286daee3.svg";